import { render, staticRenderFns } from "./PrivacyPolicyAgreementModal.vue?vue&type=template&id=b7cd0a8a&"
import script from "./PrivacyPolicyAgreementModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyAgreementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports